import React from 'react';
import { CELEBRITY_EVENT_PROMO_CODE_BANNER } from 'src/celebrity-event/Content';
import { CelebrityEventType } from 'src/gqlReactTypings.generated.d';
import { useCurrentUser } from 'src/shared/hooks/useCurrentUserHook';
import { minScreen } from 'src/shared/utils/StyledComponentUtils';
import styled from 'styled-components';
import { Colors, Font, ScreenWidth } from 'web-common/src/shared/styles';

interface IProps {
  className?: string;
  celebrityEventType?: CelebrityEventType | null;
}

const StyledBanner = styled.div`
  display: flex;
  flex-direction: row;
  align-content: center;
  justify-content: center;
  padding: 16px;
  width: 100%;
  font-size: 13px;
  background-color: ${Colors.KOHLRABI_LITE_30};

  ${minScreen(ScreenWidth.SMALL)} {
    font-size: ${Font.Size.S};
  }
`;

export const CelebrityEventPromoCodeBanner: React.FC<IProps> = ({ className, celebrityEventType }) => {
  const [currentUser] = useCurrentUser();
  const bannerContent = celebrityEventType ? CELEBRITY_EVENT_PROMO_CODE_BANNER[celebrityEventType] : null;

  // Only display to logged in new users
  if (!currentUser || currentUser.orderCount || !bannerContent) return null;

  return (
    <StyledBanner className={className}>
      <span className='self-center'>{bannerContent}</span>
    </StyledBanner>
  );
};
